export const STRIPE_PUBLISHABLE_KEY =
  process.env.NODE_ENV === "production" /* production build using npm run build */ &&
  process.env.REACT_APP_TARGET_DEPLOYMENT === "prod" /* and specified prod in the environment variable */
    ? "pk_live_51JW1q0H3o7SpP8zim0xsvwWxK5N2eUdy9Cblp5LT9vhUmjc2iVN19CNIeV4ipAnDTMlKSzZdwiitJHM4KJE62gtT00VRYRIB32"
    : "pk_test_51JW1q0H3o7SpP8ziJH2EHLg4cFlM34XAKFWJqGhkPTS7NL5I6dnVVHEMP8ebKLBCc1gchsJRT4sCMy2hp4bZDxIk00CBg9PgAT";

export default STRIPE_PUBLISHABLE_KEY;
